import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/documents/$id/audit')({
  component: DocumentAuditPage,
})

function DocumentAuditPage() {
  const { id } = Route.useParams()

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
          <div className="space-y-6">
            <div className="border-b border-gray-200 dark:border-gray-700 pb-4">
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                Document Audit Log
              </h1>
              <p className="text-gray-600 dark:text-gray-400 mt-2">
                Complete history of actions performed on this document
              </p>
            </div>

            <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md p-4">
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                Document ID:
              </p>
              <code className="text-lg font-mono bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded text-gray-900 dark:text-gray-100">
                {id}
              </code>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                Audit Trail Events (To be implemented)
              </h2>
              <div className="space-y-2 text-gray-600 dark:text-gray-400">
                <p>This page will display:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Document creation timestamp and creator</li>
                  <li>All signature events with timestamps</li>
                  <li>Document status changes</li>
                  <li>Access events (views, downloads)</li>
                  <li>Modification history</li>
                  <li>Signer notifications sent</li>
                  <li>IP addresses and user agents</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
